import { render, staticRenderFns } from "./Three2.vue?vue&type=template&id=ea8be0cc&scoped=true&"
import script from "./Three2.vue?vue&type=script&lang=js&"
export * from "./Three2.vue?vue&type=script&lang=js&"
import style0 from "./Three2.vue?vue&type=style&index=0&id=ea8be0cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8be0cc",
  null
  
)

export default component.exports